import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, ArrowRight, MapPin } from "lucide-react";
import { api } from "../lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const resolveImg = (u) => (u && u.startsWith("http") ? u : `${BACKEND}${u}`);

export default function FeaturedProject() {
    const [p, setP] = useState(null);

    useEffect(() => {
        api
            .get("/projects/featured")
            .then((r) => setP(r.data))
            .catch(() => {});
    }, []);

    if (!p) return null;

    return (
        <section
            className="section-pad bg-muted"
            data-testid="featured-project-section"
        >
            <div className="container-x">
                <div className="flex items-center gap-3 mb-10">
                    <Star
                        size={16}
                        className="text-secondary fill-secondary"
                        strokeWidth={1.5}
                    />
                    <span className="eyebrow">Featured Project</span>
                    <span className="h-px flex-1 bg-border" />
                </div>

                <article
                    className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center"
                    data-testid={`featured-${p.id}`}
                >
                    <div className="lg:col-span-7 relative">
                        <div className="aspect-[4/3] rounded-lg overflow-hidden bg-muted">
                            <img
                                src={resolveImg(p.image)}
                                alt={p.title}
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="absolute -top-4 -left-4 bg-secondary text-secondary-foreground px-4 py-2 rounded-md shadow-lg flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em]">
                            <Star size={12} fill="currentColor" />
                            Pick of the month
                        </div>
                    </div>
                    <div className="lg:col-span-5">
                        <div className="text-xs uppercase tracking-[0.2em] text-secondary font-medium">
                            {p.category}
                        </div>
                        <h3 className="mt-3 text-3xl md:text-4xl lg:text-5xl font-heading font-extrabold tracking-tight leading-[1.05]">
                            {p.title}
                        </h3>
                        <div className="mt-4 flex items-center gap-1.5 text-sm text-muted-foreground">
                            <MapPin size={14} /> {p.location}
                        </div>
                        <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed">
                            {p.description}
                        </p>
                        <Link
                            to="/quote"
                            className="btn-primary mt-8"
                            data-testid="featured-quote-btn"
                        >
                            Quote something similar <ArrowRight size={18} />
                        </Link>
                    </div>
                </article>
            </div>
        </section>
    );
}
